<!-- "Set yourself up": shown until this account has said which of its groups and tutoring are it. -->
<script lang="ts">
  import { api } from "../lib/api.ts";
  import { link } from "../lib/router.svelte.ts";

  let show = $state(false);
  let count = $state(0);
  $effect(() => {
    api<{ done: boolean; records: unknown[] }>("/api/me/setup")
      .then((r) => {
        show = !r.done && r.records.length > 0;
        count = r.records.length;
      })
      .catch(() => {});
  });
</script>

{#if show}
  <div class="prompt" role="status">
    <span><strong>Set yourself up.</strong> Add your full name and confirm the {count === 1 ? "group or tutoring" : `${count} groups and tutoring`} that are you.</span>
    <a class="btn small primary" href="/setup" use:link>Start</a>
  </div>
{/if}

<style>
  .prompt {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
    margin: 0 0 16px;
    padding: 12px 14px;
    border-radius: var(--r-lg);
    background: var(--surface);
    box-shadow: inset 0 0 0 1px var(--rule);
    font-size: var(--t-sm);
  }
</style>
